import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useRef } from 'react';
import { getProductInfoForAliases } from "../function/getProductInfo";
import { addEventSourceListener } from "../function/eventSource";
import { useSearchParams } from 'react-router-dom';
import { useUpdateEffect } from 'ahooks';
export var useAutoRefreshPlugin = function useAutoRefreshPlugin(productAliases) {
  return function (fetchInstance, _ref) {
    var _ref$ready = _ref.ready,
        ready = _ref$ready === void 0 ? true : _ref$ready,
        refreshDepsAction = _ref.refreshDepsAction;
    var canInitiate = useRef(false);
    useEffect(function () {
      var removeListener = addEventSourceListener(function (data) {
        if (data.action === 'ResourceChange') {
          var productsInfo = getProductInfoForAliases(productAliases);
          var _data$content = data.content,
              productSn = _data$content.productSn,
              productName = _data$content.productName;
          var hit = Object.entries(productsInfo).some(function (i) {
            return i[1].productSn === productSn && i[1].productName === productName;
          });

          if (ready && hit && canInitiate.current) {
            if (refreshDepsAction) {
              refreshDepsAction();
            } else {
              fetchInstance.refresh();
            }
          }
        }
      });
      return function () {
        removeListener();
      };
    }, [canInitiate.current]);
    return {
      onBefore: function onBefore() {
        canInitiate.current = true;
      }
    };
  };
};
export var usePreRenderBlockRunPlugin = function usePreRenderBlockRunPlugin() {
  return function (fetchInstance, _ref2) {
    var _ref2$ready = _ref2.ready,
        ready = _ref2$ready === void 0 ? true : _ref2$ready;

    var _useSearchParams = useSearchParams(),
        _useSearchParams2 = _slicedToArray(_useSearchParams, 1),
        searchParams = _useSearchParams2[0];

    var isPreRender = searchParams.get('isPreRender');
    var lastParams = useRef(undefined);
    useUpdateEffect(function () {
      if (ready && !!lastParams.current) {
        fetchInstance.run.apply(fetchInstance, _toConsumableArray(lastParams.current));
      }
    }, [isPreRender]);
    return {
      onBefore: function onBefore(params) {
        lastParams.current = params;

        if (isPreRender) {
          return {
            stopNow: true
          };
        }
      }
    };
  };
};
export var useBlockFirstCallPlugin = function useBlockFirstCallPlugin(fn) {
  return function (fetchInstance, _ref3) {
    var _ref3$ready = _ref3.ready,
        ready = _ref3$ready === void 0 ? true : _ref3$ready;
    var isFirst = useRef(true);
    return {
      onBefore: function onBefore(params) {
        if (isFirst.current) {
          isFirst.current = false;
        } else {
          var _fn$onBefore;

          fn === null || fn === void 0 ? void 0 : (_fn$onBefore = fn.onBefore) === null || _fn$onBefore === void 0 ? void 0 : _fn$onBefore.call(fn);
        }
      }
    };
  };
};